export default {
  COLABORADOR: 1,
  GESTOR: 2,
  ADMINISTRADOR: 3,
};
